<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  field: any;
  rowData: any;
  settings: any;
}>();

const dynamicKey = computed(() => props.settings.render.dynamicKey);
const targetRef = computed(() => {
  const { href, targetKey, secondaryKey } = props.settings.render;

  if (secondaryKey) {
    const primary = props.rowData[targetKey[0]];
    const secondary = props.rowData[secondaryKey[0]];

    if (primary != null && secondary != null) return `${href}${primary}/${secondary}`;
    if (primary != null) return `${href}${primary}`;

    return '';
  }

  return targetKey.length > 1
    ? `${href}${props.rowData[targetKey[0]][targetKey[1]]}`
    : `${href}${props.rowData[targetKey]}`;
});
</script>

<template>
  <span
    v-if="!field"
    class="flex flex-col items-start gap-0.5"
  >
    -
  </span>

  <RouterLink
    v-else
    class="text-sky-600 transition-colors hover:text-sky-900 hover:underline"
    :to="targetRef"
  >
    {{ rowData[dynamicKey] }} - {{ field }}
  </RouterLink>
</template>
